import { Component, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { ProgramService } from 'src/app/shared/services/program.service';
import { AppSettings } from '../../../app.constant';
import { User } from '../../../shared/interface/user';
import { DataSource } from '@angular/cdk/table';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';

@Component({
  selector: 'program-table',
  templateUrl: './program-table.component.html',
  styleUrls: ['./program-table.component.css']
})

export class ProgramTableComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['ProgramCode', 'ProgramName', 'Duration', 'Edit'];
  httpResponseMessage: any;
  post: any;
  resultdata: any;
  dataSource: any;
  Program: any;
  status: any;
  errorMessage: String;
  progressBar: boolean = true;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _programservice: ProgramService,
    changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  ngOnInit() {
    this._programservice.refreshNeeded$
      .subscribe(() => {
        this.getAllProgram();
      })

    this.getAllProgram();
  }

  getAllProgram() {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }
        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  onEditProgram(param: any): void {
    var o = { PK_ProgramID: param.PK_ProgramID }
    this.post = JSON.stringify(o);
    this._programservice.getProgramByID(AppSettings.API_ENDPOINT + AppSettings.GetProgramByID, this.post).subscribe(
      data => {
        this.Program = data;
        console.table(this.Program);
        this.messageEvent.emit(this.Program);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteProgram(param: any): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Program",
      data: param.ProgramName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_ProgramID: param.PK_ProgramID }
        this.post = JSON.stringify(o);
        this._programservice.deleteProgramByID(AppSettings.API_ENDPOINT + AppSettings.DeleteProgram, this.post).subscribe(
          data => {
            this.httpResponseMessage = data
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });
  }


  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}

